import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { getMortarMixture } from '@/service/production/ProReportMortar';
export default function useMixture(params) {
  var list1 = ref([]);
  var list2 = ref([]);
  // 获取制砂总汇
  var getMortarMixtureAsync1 = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMortarMixture(_objectSpread(_objectSpread({}, params.value), {}, {
              lineNum: 1
            }));
          case 2:
            data = _context.sent;
            list1.value = data.list;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getMortarMixtureAsync1() {
      return _ref.apply(this, arguments);
    };
  }();
  var getMortarMixtureAsync2 = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getMortarMixture(_objectSpread(_objectSpread({}, params.value), {}, {
              lineNum: 2
            }));
          case 2:
            data = _context2.sent;
            list2.value = data.list;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getMortarMixtureAsync2() {
      return _ref2.apply(this, arguments);
    };
  }();
  var mixtureData1 = computed(function () {
    return {
      pieData: list1.value.map(function (item) {
        return {
          name: item.stone_name,
          value: item.net_weight
        };
      }).filter(function (item) {
        return item.value;
      }),
      unit: 'kg',
      customTooltip: true,
      tooltipFormatter: function tooltipFormatter(params) {
        return "\n          <div >\n            <div class=\"flex align-start\">\n              <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n              <div>\n                <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                <div>\n                 <span style=\"font-size: 12px;\">").concat(params.value, "kg</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          ");
      }
    };
  });
  var mixtureData2 = computed(function () {
    return {
      pieData: list2.value.map(function (item) {
        return {
          name: item.stone_name,
          value: item.net_weight
        };
      }).filter(function (item) {
        return item.value;
      }),
      unit: 'kg',
      customTooltip: true,
      tooltipFormatter: function tooltipFormatter(params) {
        return "\n          <div >\n            <div class=\"flex align-start\">\n              <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n              <div>\n                <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                <div>\n                 <span style=\"font-size: 12px;\">").concat(params.value, "kg</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          ");
      }
    };
  });
  return [mixtureData1, mixtureData2, getMortarMixtureAsync1, getMortarMixtureAsync2];
}